import { useEffect } from 'react';

const useStickyCard = (isMobile, compareItemWidth) => {
	const marginStickyValue = 10;

	useEffect(() => {
		const stickyCardContainer = document?.querySelector(
			'.ws-vehicle-compare .sticky-card-container'
		);
		const compareButton = document?.querySelector(
			'.ws-vehicle-compare .compare-done-button'
		);

		if (compareButton) {
			compareButton.style.marginTop = `-${stickyCardContainer?.offsetHeight}px`;
		}

		const adjustOverflowMobile = () => {
			if (isMobile) {
				const ddcDocument = document?.querySelector('.ddc-document');

				if (ddcDocument) {
					const ddcPage = ddcDocument?.querySelector('.ddc-page');

					const { marginTop, paddingTop } = ddcPage.style;

					// Only adjust the first time
					if (!paddingTop) {
						ddcDocument.style.overflow = 'visible';
						ddcPage.style.marginTop = '';
						ddcPage.style.paddingTop = marginTop;
					}
				}
			}
		};

		const scrollWithSticky = () => {
			let stickyPosition = 0;
			const imgVehicleContainer = document?.querySelector(
				'.ws-vehicle-compare .img-container'
			);
			const pageHeader = document?.querySelector('.page-header');
			if (stickyCardContainer && imgVehicleContainer) {
				const pageHeaderHeight = pageHeader?.offsetHeight || 0;
				const navbarHeight =
					document?.querySelector('.navbar')?.offsetHeight || 0;
				const clientReactBottom =
					imgVehicleContainer.getBoundingClientRect().bottom;

				if (pageHeader?.classList.contains('shrink-header-nav')) {
					// Collapse Header on Desktop
					stickyPosition = pageHeaderHeight + navbarHeight;
				} else {
					// Collapse Header on Mobile
					stickyPosition =
						pageHeaderHeight > 0 ? pageHeaderHeight : navbarHeight;
				}

				// Set position for sticky card
				stickyCardContainer.style.top = `${
					stickyPosition + marginStickyValue
				}px`;
				if (clientReactBottom - stickyPosition <= 0) {
					stickyCardContainer.classList.add('show');

					adjustOverflowMobile();
				} else {
					stickyCardContainer.classList.remove('show');
				}
			}
		};

		window?.addEventListener(
			'scroll',
			window?._?.throttle(scrollWithSticky, 400)
		);

		return () => {
			window?.removeEventListener('scroll', scrollWithSticky);
		};
	}, [isMobile, compareItemWidth]);
};

export default useStickyCard;
